import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../../generic/Icon';

import styles from './ProjectPreview.module.less';

type Props = {
  deepestLevel: number;
  issueCount: number;
};

/**
 * Header content displayed when the license scan has found issues
 */
const HeaderContentFailing: VoidFunctionComponent<Props> = ({ deepestLevel, issueCount }) => (
  <>
    <h2 className={`margin-top margin-top-responsive ${styles.headerTitleFailing}`}>
      <span className={styles.failingIcon}>
        <Icon icon={icons.triangleExclamation} />
      </span>
      License scan found {issueCount} issue{issueCount > 1 ? 's' : ''}
    </h2>
    <span className={styles.headerSubtextFailing}>
      Last scanned <strong>4 hours ago</strong>
      <br />
      {deepestLevel > 0 ? `Found dependencies ${deepestLevel} levels deep` : ''}
    </span>
  </>
);

export default HeaderContentFailing;
